"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var colors = _interopRequireWildcard(require("../../style/colors"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Svg",
  componentId: "sc-1foy734-0"
})(["", ""], function (_ref) {
  var rotate = _ref.rotate;
  return "transform: rotate(".concat(rotate, "deg)");
});

var CheckedIcon = function CheckedIcon(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      stroke = _ref2.stroke,
      rotate = _ref2.rotate,
      viewBox = _ref2.viewBox;
  return _react["default"].createElement(Svg, {
    rotate: rotate,
    width: width,
    height: height,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    transform: "translate(-1 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("rect", {
    fill: stroke,
    x: "1.6",
    y: "1.6",
    width: "12.8",
    height: "12.8",
    rx: "6.4"
  }), _react["default"].createElement("path", {
    d: "M10.31034121 6.1162298L7.06274144 9.36382955l-.98485824-.98485824c-.08091664-.08091664-.21210843-.08091664-.29302507 0-.08091664.08091664-.08091664.21210842 0 .29302506l1.13137085 1.13137085c.03975759.03975759.09137027.0606874.14651237.06068737.0551421 0 .1067549-.02092984.14651253-.06068747L10.6033662 6.4092548c.08091664-.08091664.08091665-.2121084 3e-8-.29302503-.08091662-.08091662-.2121084-.0809166-.29302503 2e-8z",
    stroke: "#FFF",
    strokeWidth: "1.186"
  })));
};

CheckedIcon.propTypes = {
  width: _propTypes.PropTypes.string,
  height: _propTypes.PropTypes.string,
  stroke: _propTypes.PropTypes.string,
  rotate: _propTypes.PropTypes.number,
  viewBox: _propTypes.PropTypes.string
};
CheckedIcon.defaultProps = {
  width: '60px',
  height: '60px',
  stroke: colors.green,
  rotate: 0,
  viewBox: '0 0 30 30'
};
var _default = CheckedIcon;
exports["default"] = _default;